module.exports = __webpack_public_path__ + "img/squirrel.82896d5c.png";